import React from 'react';
import { Building2, Wrench, Truck, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const metiers = [
  {
    icon: Building2,
    title: 'BTP & Génie Civil',
    accroche: "Nous réalisons vos travaux de terrassement, génie civil et construction avec exigence, sécurité et performance.",
    cta: 'Découvrir nos solutions',
    target: 'btp',
    image: 'https://images.pexels.com/photos/31674013/pexels-photo-31674013.jpeg?auto=compress&cs=tinysrgb&w=940',
    color: 'green',
  },
  {
    icon: Wrench,
    title: 'Mécanique & Hydraulique',
    accroche: "Réparation, maintenance, vérins, tournage et solutions hydrauliques pour optimiser la performance de vos équipements.",
    cta: 'Découvrir nos services',
    target: 'mecanique-hydraulique',
    image: 'https://images.unsplash.com/photo-1565954786194-d22abeaac3ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=940',
    color: 'orange',
  },
  {
    icon: Truck,
    title: 'Location de Matériel',
    accroche: "Des équipements fiables et disponibles pour accompagner efficacement vos projets et vos chantiers.",
    cta: 'Voir notre parc matériel',
    target: 'location',
    image: 'https://images.unsplash.com/photo-1603814744450-36f978490b11?crop=entropy&cs=srgb&fm=jpg&q=85&w=940',
    color: 'green',
  },
];

export const Metiers = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="metiers" className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-green-600">Métiers</span>
          </h2>
          <p className="text-lg text-gray-700">
            Une offre intégrée au service des entreprises du BTP, de l'industrie, de l'énergie et des infrastructures.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {metiers.map((m, i) => (
            <Card
              key={i}
              data-testid={`metier-card-${m.target}`}
              className="group hover:shadow-2xl transition-all duration-300 overflow-hidden bg-white border-gray-200 flex flex-col"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={m.image}
                  alt={m.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/85 via-gray-900/30 to-transparent"></div>
                <div className={`absolute top-4 left-4 p-3 rounded-full ${m.color === 'green' ? 'bg-green-600' : 'bg-orange-500'}`}>
                  <m.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="absolute bottom-4 left-4 right-4 text-2xl font-bold text-white">{m.title}</h3>
              </div>
              <CardContent className="p-6 flex flex-col flex-1">
                <p className="text-gray-600 leading-relaxed mb-6 flex-1">{m.accroche}</p>
                <Button
                  onClick={() => scrollTo(m.target)}
                  className={`w-full text-white ${m.color === 'green' ? 'bg-green-600 hover:bg-green-700' : 'bg-orange-500 hover:bg-orange-600'}`}
                  data-testid={`metier-cta-${m.target}`}
                >
                  {m.cta}
                  <ArrowRight className="h-4 w-4 ml-2" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
